import firebase from "services/FirebaseService";
import { dispatch } from "whiteboard/AppStore";

const db = firebase.firestore();

const defaultState = {
  user: {},
  profile: {},
  isLoggedIn: false
};

const model = {
  state: defaultState,
  reducers: {
    setUserData(_state, payload) {
      if (!payload) {
        return defaultState;
      }
      const state = {};
      state.user = payload;
      state.isLoggedIn = true;
      state.profile = {
        uid: payload.uid,
        displayName: payload.displayName,
        email: payload.email,
        emailVerified: payload.emailVerified,
        phoneNumber: payload.phoneNumber,
        photoURL: payload.photoURL
      };
      return state;
    },
    updateProfile(state, profile) {
      return { ...state, profile };
    }
  },
  effects: {
    async setupAuth(payload, rootState) {
      firebase.auth().onAuthStateChanged(user => {
        if (!user) {
          return dispatch.auth.setUser(undefined);
        }
        dispatch.auth.setUser(user);
        dispatch.auth.watchProfile();
      });
    },
    async setUser(user, rootState) {
      this.setUserData(user);
    },
    async logout(payload, rootState) {
      firebase.auth().signOut();
    },
    async ghost(profile, rootState) {
      this.updateProfile(profile);
      dispatch.account.profileUpdated();
    },
    // get saved pocketmod profile, or create one if first time here
    async watchProfile(payload, rootState) {
      const user = await db
        .collection("users")
        .doc(rootState.auth.profile.uid)
        .onSnapshot(doc => {
          const profile = doc.data();
          this.updateProfile(profile);
          dispatch.account.profileUpdated(profile);
          dispatch.ui.loadPublicUIData();
        });
      dispatch.account.profileUpdated();
    }
  }
};

export default model;



// WEBPACK FOOTER //
// ./src/whiteboard/models/auth.js